<template>
  <div class="animated fadeIn">
    <b-card class="mt-4">
      <feeds-field-form-group
        :submission="submission_data"
        :index="index"
        @onFieldChange="onFieldChange"
      ></feeds-field-form-group>
      <div v-if="submission_data.samples && submission_data.samples.length">
        <hr />
        <feeds-sample-form-group
          v-for="(sample, index) in submission_data.samples"
          :key="index"
          :sample="sample"
          :addOns="addOns"
          :index="index"
          :typeOptions="typeOptions"
          :animalFedOptions="animalFedOptions"
          :managedListId="managedListId"
          @onSampleChange="onSampleChange"
        ></feeds-sample-form-group>
      </div>
      <div v-if="turnArounds && turnArounds.models.length">
        <hr />
        <turn-around-select
          :turnArounds="turnArounds"
          :selectedTurnAround="submission_data.turnaround"
          @onTurnAroundSelect="onTurnAroundSelect"
        ></turn-around-select>
      </div>
      <div v-if="serviceQuestions && serviceQuestions.models.length">
        <hr />
        <service-question
          v-for="(serviceQuestion, index) in serviceQuestions.models"
          :key="index"
          :serviceQuestion="serviceQuestion"
        ></service-question>
      </div>
      <b-button variant="danger" block @click="removeSubmission"
        ><i class="fal fa-trash"></i
      ></b-button>
    </b-card>
  </div>
</template>

<script>
import FeedsFieldFormGroup from "./FeedsFieldFormGroup";
import FeedsSampleFormGroup from "./FeedsSampleFormGroup";
import TurnAroundSelect from "../../TurnAroundSelect";
import TestPackageSampleCollection from "../../../../collections/lab/TestPackageSampleCollection";
import TestPackageCollection from "../../../../collections/lab/TestPackageCollection";
import ToastNotifications from "@/components/shared/mixins/ToastNotifications";
import TurnaroundCollection from "../../../../collections/lab/TurnaroundCollection";
import ServiceQuestionCollection from "../../../../collections/lab/ServiceQuestionCollection";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
  name: "FeedsForm",
  components: {
    FeedsFieldFormGroup,
    FeedsSampleFormGroup,
    TurnAroundSelect
  },
  mixins: [validationMixin, ToastNotifications],
  props: {
    submission: {
      type: Object,
      default: () => null
    },
    testPackageSamples: {
      type: Object,
      default: () => new TestPackageSampleCollection()
    },
    addOns: {
      type: Object,
      default: () => new TestPackageCollection()
    },
    turnArounds: {
      type: Object,
      default: () => new TurnaroundCollection()
    },
    serviceQuestions: {
      type: Object,
      default: () => new ServiceQuestionCollection()
    },
    index: {
      type: Number,
      default: null
    },
    typeOptions: {
      type: Object,
      default: () => {
        return {};
      }
    },
    animalFedOptions: {
      type: Object,
      default: () => {
        return {};
      }
    },
    managedListId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      submission_data: null
    };
  },
  validations: {
    submission_data: {
      identifier: { required }
    }
  },
  methods: {
    onFieldChange(data) {
      if (data) {
        this.submission_data.identifier = data.identifier;
        this.submission_data.event_code = data.event_code;
        this.emitSubmissionChange();
      }
    },
    onSampleChange(params) {
      if (params) {
        let sample = params.sample;
        let index = params.index;
        if (
          this.submission_data.samples &&
          this.submission_data.samples.length &&
          sample &&
          index !== null
        ) {
          this.submission_data.samples.splice(index, 1, sample);
          this.emitSubmissionChange();
        }
      }
    },
    onTurnAroundSelect(turnaround) {
      if (turnaround && turnaround.id) {
        this.submission_data.turnaround = turnaround;
        this.submission_data.turnaround_id = turnaround.id;
        this.emitSubmissionChange();
      } else {
        this.submission_data.turnaround = null;
        this.submission_data.turnaround_id = null;
        this.emitSubmissionChange();
      }
    },
    emitSubmissionChange() {
      this.$emit("onSubmissionChange", {
        submission: this.submission_data,
        index: this.index
      });
    },
    removeSubmission() {
      this.$emit("removeSubmission", this.index);
    }
  },
  watch: {
    submission: {
      handler(value) {
        this.submission_data = value;
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    if (this.submission) {
      this.submission_data = this.submission;
    }
  }
};
</script>
